import React from 'react';

const PALETTE = [
  { bg: '#DBEAFE', color: '#1D4ED8' },
  { bg: '#FEF3C7', color: '#92400E' },
  { bg: '#EDE9FE', color: '#6D28D9' },
  { bg: '#CFFAFE', color: '#0E7490' },
  { bg: '#FCE7F3', color: '#9D174D' },
];
const COMPLETED = { bg: '#D1FAE5', color: '#065F46' };
const CANCELLED = { bg: '#FEE2E2', color: '#991B1B' };

// Badge para el status de un Expediente: color por posición de etapa (paleta cíclica),
// verde fijo si ya llegó a la última etapa del tipo, rojo fijo si está Cancelado.
const StatusBadge = ({ status, stageType, order }) => {
  let style;
  if (stageType === 'completed') style = COMPLETED;
  else if (stageType === 'cancelled') style = CANCELLED;
  else style = PALETTE[Math.max((order || 1) - 1, 0) % PALETTE.length];

  return (
    <span style={{ display: 'inline-flex', padding: '3px 9px', borderRadius: 20, fontSize: 11, fontWeight: 600, backgroundColor: style.bg, color: style.color, whiteSpace: 'nowrap' }}>
      {status || '—'}
    </span>
  );
};

export default StatusBadge;
